import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi/BookingManagerApi';
import { IPurchaseOrderReviewRequest } from 'services/BookingManagerApi/types/PurchaseOrdersSearchResponse';
import { PURCHASE_ORDER_DETAIL_QUERY_KEY } from './usePurchaseOrderDetailQuery';

export const useReviewPurchaseOrderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: IPurchaseOrderReviewRequest) => {
      const response = await makeBookingManagerApi().reviewPurchaseOrder(payload);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PURCHASE_ORDER_DETAIL_QUERY_KEY] });
    },
  });
};
